import { render } from "./connect.vue?vue&type=template&id=23e0f865&scoped=true"
import script from "./connect.vue?vue&type=script&lang=js"
export * from "./connect.vue?vue&type=script&lang=js"

import "./connect.vue?vue&type=style&index=0&id=23e0f865&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23e0f865"]])

export default __exports__